import { Component } from '@angular/core';
import { LoaderService } from '../app/Component/Loader/loader.service';
import { HttpClient } from '@angular/common/http';
import { Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserAuthManager } from './Services/user-sessions/user-auth-manager';
import { SessionService } from './Services/session.service';
import { UserManagementService } from './Services/user-management/user-management.service';
import { AuthService } from './Services/services/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'PerfectLearning';
  router: boolean = false;
  visibility: boolean = environment.visibility;
  loginVisible: boolean = environment.loginVisible;

  isLoading: Subject<boolean> = this.loaderService.isLoading;

  private tokenCheckIntervalId: any = null;
private logoutSub!: Subscription;
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private sessionService: SessionService,
    private userService: UserManagementService,
  ) {}

  ngOnInit() {
    console.log(environment.env);

    this.logoutSub = AuthService.userSessionLogout.subscribe(() => {

      console.log("we logged out");

      this.clearTokenWatcher();
    });

    if (environment.production || environment.env === 'development') {
      if (window) {
        window.console.log = () => {};
        window.console.warn = () => {};
        window.console.info = () => {};
      }
    }

    if (this.isUserLoggedIn()) {
      this.startTokenWatcher();
    }
  }

  ngOnDestroy() {
    this.clearTokenWatcher();
        if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  onOpen(visible: any) {
    console.log(visible,"visible");
        if (visible && this.isUserLoggedIn()) {
      this.startTokenWatcher();
    }
    this.visibility = visible;
    this.loginVisible = !visible;

    // if we just logged in (visible=true), make sure watcher is running

  }

  private isUserLoggedIn(): boolean {
    const token = localStorage.getItem('userToken');
    return !!token;
  }

  private startTokenWatcher(): void {
    if (this.tokenCheckIntervalId !== null) return;

    this.checkExpiryUsingLocalString();

    this.tokenCheckIntervalId = setInterval(() => {
      this.checkExpiryUsingLocalString();
    }, 20000);
  }

  private clearTokenWatcher(): void {
    if (this.tokenCheckIntervalId !== null) {
      clearInterval(this.tokenCheckIntervalId);
      this.tokenCheckIntervalId = null;
    }
  }

  checkExpiryUsingLocalString(): void {
    const expiresLocalStr = localStorage.getItem('expires_at_local');
    if (!expiresLocalStr) {
      return;
    }

    const expiresDate = new Date(expiresLocalStr);
    const nowDate = new Date();

    const expiresMs = expiresDate.getTime();
    const nowMs = nowDate.getTime();

    const timeLeftMs = expiresMs - nowMs;

    const fiveMinutesMs = 5 * 60 * 1000;
    if (timeLeftMs <= fiveMinutesMs) {
      const refreshToken = this.sessionService.getRefreshToken();

      if (refreshToken) {
        console.log('⚠ about to expire, attempting refresh');
        this.userService.refreshToken(refreshToken).subscribe({
          next: (res: any) => {
            localStorage.setItem('userToken', res.access_token);
            localStorage.setItem('refresh_token', res.refresh_token);

            const newExpiresUtc = new Date(res['.expires']);
            const newIssuedUtc = new Date(res['.issued']);

            localStorage.setItem('expires_at_local', newExpiresUtc.toString());
            localStorage.setItem('issued_at_local', newIssuedUtc.toString());

            localStorage.setItem('expires_at_ts', newExpiresUtc.getTime().toString());
            localStorage.setItem('issued_at_ts', newIssuedUtc.getTime().toString());
            localStorage.setItem('loginuser', res.username);
            localStorage.setItem('roles', res.roles);

            console.log('✅ token refreshed');
          },
          error: (err) => {
            console.error('❌ token refresh failed', err);
          }
        });
      }
    } else {
      console.log('session still valid, no refresh needed');
    }
  }
}

